module.exports = __webpack_public_path__ + "img/hero-image-compra-mobile.ad758dd4.png";